let idTmr;
function transform(table,name,wareType,waterType) {
  let mydate=new Date();
  let nowDate=mydate.toLocaleString();
  let tableInnerHTML=`<!DOCTYPE html>
                        <html lang="en">
                        <head>
                          <meta charset="UTF-8">
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                          <meta http-equiv="X-UA-Compatible" content="ie=edge">
                          <title>Document</title>
                          <style>
                            *{
                              margin: 0;
                              padding: 0
                            }
                            table{
                              border: .5px solid;
                              border-collapse:collapse;
                            }
                            tr{
                              border-bottom: 0.5px solid
                            }
                            td{
                              width: 60px;
                              text-align: center;
                              height:25px;
                              border-right: 0.5px solid
                            }
                            .sure{
                              height: 40px;
                            }
                          </style>
                        </head>
                        <body>`
  if(wareType==0){
    tableInnerHTML+=`<table>
                      <thead>
                        <tr>
                          <th colspan="16" style="font-size:20px;font-family:'楷体';height: 30px">${table.wareName}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="2"></td>`
    for(let i=0;i<table.mirColumn;i++){
      tableInnerHTML+=`<td>第${i+1}列</td>`
    }
    for(let i=0;i<14-table.mirColumn;i++){
      tableInnerHTML+=`<td></td>`
    }
    tableInnerHTML+=`</tr>`
    for(let i=0;i<table.mirRow;i++){
      tableInnerHTML+=`<tr>
                        <td rowspan="${table.mirLayer}">第${i+1}行</td><td>第1层</td>`
      for(let k=0;k<table.mirColumn;k++){
        if(waterType=='hum'){
          tableInnerHTML+=`<td>${table.pointList[0][i][k].hum||table.pointList[0][i][k].hum==0?table.pointList[0][i][k].hum:''}</td>`
        }else if(waterType=='water'){
          tableInnerHTML+=`<td>${table.pointList[0][i][k].water||table.pointList[0][i][k].water==0?table.pointList[0][i][k].water:''}</td>`
        }else{
          tableInnerHTML+=`<td>${table.pointList[0][i][k].value||table.pointList[0][i][k].value==0?table.pointList[0][i][k].value:''}</td>`
        }
      }
      for(let k=0;k<14-table.mirColumn;k++){
        tableInnerHTML+=`<td></td>`
      }
      for(let j=1;j<table.mirLayer;j++){
        tableInnerHTML+=`<tr>
                          <td>第${j+1}层</td>`
        for(let k=0;k<table.mirColumn;k++){
          if(waterType=='hum'){
            tableInnerHTML+=`<td>${table.pointList[j][i][k].hum||table.pointList[j][i][k].hum==0?table.pointList[j][i][k].hum:''}</td>`
          }else if(waterType=='water'){
            tableInnerHTML+=`<td>${table.pointList[j][i][k].water||table.pointList[j][i][k].water==0?table.pointList[j][i][k].water:''}</td>`
          }else{
            tableInnerHTML+=`<td>${table.pointList[j][i][k].value||table.pointList[j][i][k].value==0?table.pointList[j][i][k].value:''}</td>`
          }
        }
        for(let k=0;k<14-table.mirColumn;k++){
          tableInnerHTML+=`<td></td>`
        }
        tableInnerHTML+=`</tr>`
      }
      tableInnerHTML+=`</tr>`
    }
    if(waterType=='hum'){
      tableInnerHTML+=`<tr>
                      <td colspan="2"></td>
                      <td colspan="2">最高湿度</td>
                      <td colspan="2">最低湿度</td>
                      <td colspan="2">平均湿度</td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                    </tr>`
    }else if(waterType=='water'){
      tableInnerHTML+=`<tr>
                      <td colspan="2"></td>
                      <td colspan="2">最高水分</td>
                      <td colspan="2">最低水分</td>
                      <td colspan="2">平均水分</td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                    </tr>`
    }else{
      tableInnerHTML+=`<tr>
                      <td colspan="2"></td>
                      <td colspan="2">最高温度</td>
                      <td colspan="2">最低温度</td>
                      <td colspan="2">平均温度</td>
                      <td colspan="2">周均温度</td>
                      <td colspan="2">内均温度</td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                    </tr>`
    }
    table.infos.forEach((item,index)=>{
      if(waterType=='hum'){
        tableInnerHTML+=`<tr>
                        <td colspan="2">第${index+1}层</td>
                        <td colspan="2">${item.infoHumMax||item.infoHumMax==0?item.infoHumMax:''}</td>
                        <td colspan="2">${item.infoHumMin||item.infoHumMin==0?item.infoHumMin:''}</td>
                        <td colspan="2">${item.infoHumAve||item.infoHumAve==0?item.infoHumAve:''}</td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                      </tr>`
      }else if(waterType=='water'){
        tableInnerHTML+=`<tr>
                        <td colspan="2">第${index+1}层</td>
                        <td colspan="2">${item.infoWaterMax||item.infoWaterMax==0?item.infoWaterMax:''}</td>
                        <td colspan="2">${item.infoWaterMin||item.infoWaterMin==0?item.infoWaterMin:''}</td>
                        <td colspan="2">${item.infoWaterAve||item.infoWaterAve==0?item.infoWaterAve:''}</td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                      </tr>`
      }else{
        tableInnerHTML+=`<tr>
                        <td colspan="2">第${index+1}层</td>
                        <td colspan="2">${item.tempMax||item.tempMax==0?item.tempMax:''}</td>
                        <td colspan="2">${item.tempMin||item.tempMin==0?item.tempMin:''}</td>
                        <td colspan="2">${item.tempAve||item.tempAve==0?item.tempAve:''}</td>
                        <td colspan="2">${item.zTempAve||item.zTempAve==0?item.zTempAve:''}</td>
                        <td colspan="2">${item.nTempAve||item.nTempAve==0?item.nTempAve:''}</td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                      </tr>`
      }
    })
    tableInnerHTML+=`<tr>
                      <td colspan="2">整仓</td>`
    if(waterType=='hum'){
      tableInnerHTML+=`<td colspan="2">${table.humMax||table.humMax==0?table.humMax:''}</td>
                      <td colspan="2">${table.humMin||table.humMin==0?table.humMin:''}</td>
                      <td colspan="2">${table.humAve||table.humAve==0?table.humAve:''}</td>`
    }else if(waterType=='water'){
      tableInnerHTML+=`<td colspan="2">${table.waterMax||table.waterMax==0?table.waterMax:''}</td>
                      <td colspan="2">${table.waterMin||table.waterMin==0?table.waterMin:''}</td>
                      <td colspan="2">${table.waterAve||table.waterAve==0?table.waterAve:''}</td>`
    }else{
      tableInnerHTML+=`<td colspan="2">${table.tempMax||table.tempMax==0?table.tempMax:''}</td>
                      <td colspan="2">${table.tempMin||table.tempMin==0?table.tempMin:''}</td>
                      <td colspan="2">${table.tempAve||table.tempAve==0?table.tempAve:''}</td>`
    }
    tableInnerHTML+=`<td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                      <td colspan="2"></td>
                    </tr>
                    <tr>
                      <td colspan="2">仓温</td>
                      <td colspan="2">${table.tempIn||table.tempIn==0?table.tempIn:''}</td>
                      <td colspan="2">仓湿</td>
                      <td colspan="2">${table.humidityIn||table.humidityIn?table.humidityIn:''}</td>
                      <td colspan="2">气温</td>
                      <td colspan="2">${table.tempOut||table.tempOut?table.tempOut:''}</td>
                      <td colspan="2">气湿</td>
                      <td colspan="2">${table.humidityOut||table.humidityOut?table.humidityOut:''}</td>
                    </tr>
                    <tr>
                      <td colspan="4">仓房类型</td>
                      <td colspan="4">平房仓</td>
                      <td colspan="4">入仓时间</td>
                      <td colspan="4">${table.dateOfIn?table.dateOfIn:''}</td>
                    </tr>
                    <tr>
                      <td colspan="4">粮食品种</td>
                      <td colspan="4">${table.foodFariety?table.foodFariety:''}</td>
                      <td colspan="4">实际储量</td>
                      <td colspan="4">${table.storageReal||table.storageReal==0?table.storageReal:''}</td>
                    </tr>
                    <tr>
                      <td colspan="4">入仓水分</td>
                      <td colspan="4">${table.grainInWater||table.grainInWater==0?table.grainInWater:''}</td>
                      <td colspan="4">当前水分</td>
                      <td colspan="4">${table.grainWater||table.grainWater==0?table.grainWater:''}</td>
                    </tr>
                    <tr>
                      <td colspan="4">检验人</td>
                      <td colspan="4">${table.createBy?table.createBy:''}</td>
                      <td colspan="4">保管员</td>
                      <td colspan="4">${table.custodian?table.custodian:''}</td>
                    </tr>
                    <tr>
                      <td colspan="4">粮情分析</td>
                      <td colspan="12"></td>
                    </tr>
                    <tr>
                      <td colspan="2">粮食安危及虫害处理情况</td>
                      <td colspan="6"></td>
                      <td colspan="2">"一符四无"粮食鉴定意见</td>
                      <td colspan="6"></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="2">采集完成时间</td>
                      <td colspan="14">${table.createTime?table.createTime:''}</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="sure">制表时间</td>
                      <td colspan="14">${nowDate}</td>
                    </tr>
                  </tfoot>
                </table>			
                </body>
                </html>`
  }else if(wareType==1){
    let lie=0;
    if(table.mirColumn<=8){
      lie=8
    }else if(table.mirColumn>8&&table.mirColumn<=16){
      lie=16
    }else if(table.mirColumn>18&&table.mirColumn<=24){
      lie=24
    }else if(table.mirColumn>24&&table.mirColumn<=32){
      lie=32
    }else if(table.mirColumn>32&&table.mirColumn<=40){
      lie=40
    }else{
      lie=48
    }
    tableInnerHTML+=`<table>
                      <thead>
                        <tr>
                          <th colspan="${lie}" style="font-size:20px;font-family:'楷体';height: 30px">${table.wareName}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>`
    for(let i=0;i<table.mirColumn;i++){
      tableInnerHTML+=`<td>第${i+1}根</td>`
    }
    for(let i=1;i<lie-table.mirColumn;i++){
      tableInnerHTML+=`<td></td>`
    }
    tableInnerHTML+=`</tr>`
    table.pointList.forEach((item,index)=>{
      let num=0
      tableInnerHTML+=`<tr>
                        <td>第${index+1}层</td>`
      item.forEach(event=>{
        event.forEach(point=>{
          num++
          if(waterType=='hum'){
            tableInnerHTML+=`<td>${point.hum}</td>`
          }else if(waterType=='water'){
            tableInnerHTML+=`<td>${point.water}</td>`
          }else{
            tableInnerHTML+=`<td>${point.value}</td>`
          }
        })
      })
      for(let i=1;i<lie-num;i++){
        tableInnerHTML+=`<td></td>`
      }
      tableInnerHTML+=`</tr>`
    })
    if(waterType=='hum'){
      tableInnerHTML+=`<tr>
                      <td colspan="${lie/4}"></td>
                      <td colspan="${lie/4}">最高湿度</td>
                      <td colspan="${lie/4}">最低湿度</td>
                      <td colspan="${lie/4}">平均湿度</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">整仓</td>
                      <td colspan="${lie/4}">${table.humMax||table.humMax==0?table.humMax:''}</td>
                      <td colspan="${lie/4}">${table.humMin||table.humMin==0?table.humMin:''}</td>
                      <td colspan="${lie/4}">${table.humAve||table.humAve==0?table.humAve:''}</td>
                    </tr>
                    <tr>`
    }else if(waterType=='water'){
      tableInnerHTML+=`<tr>
                      <td colspan="${lie/4}"></td>
                      <td colspan="${lie/4}">最高水分</td>
                      <td colspan="${lie/4}">最低水分</td>
                      <td colspan="${lie/4}">平均水分</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">整仓</td>
                      <td colspan="${lie/4}">${table.waterMax||table.waterMax==0?table.waterMax:''}</td>
                      <td colspan="${lie/4}">${table.waterMin||table.waterMin==0?table.waterMin:''}</td>
                      <td colspan="${lie/4}">${table.waterAve||table.waterAve==0?table.waterAve:''}</td>
                    </tr>
                    <tr>`
    }else{
      tableInnerHTML+=`<tr>
                      <td colspan="${lie/4}"></td>
                      <td colspan="${lie/4}">最高温</td>
                      <td colspan="${lie/4}">最低温</td>
                      <td colspan="${lie/4}">平均温</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">整仓</td>
                      <td colspan="${lie/4}">${table.tempMax||table.tempMax==0?table.tempMax:''}</td>
                      <td colspan="${lie/4}">${table.tempMin||table.tempMin==0?table.tempMin:''}</td>
                      <td colspan="${lie/4}">${table.tempAve||table.tempAve==0?table.tempAve:''}</td>
                    </tr>
                    <tr>`
    }
    tableInnerHTML+=`<td colspan="${lie/8}">仓温</td>
                      <td colspan="${lie/8}">${table.tempIn||table.tempIn==0?table.tempIn:''}</td>
                      <td colspan="${lie/8}">仓湿</td>
                      <td colspan="${lie/8}">${table.humidityIn||table.humidityIn==0?table.humidityIn:''}</td>
                      <td colspan="${lie/8}">气温</td>
                      <td colspan="${lie/8}">${table.tempOut||table.tempOut==0?table.tempOut:''}</td>
                      <td colspan="${lie/8}">气湿</td>
                      <td colspan="${lie/8}">${table.humidityOut||table.humidityOut==0?table.humidityOut:''}</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">仓房类型</td>
                      <td colspan="${lie/4}">浅圆仓</td>
                      <td colspan="${lie/4}">入仓时间</td>
                      <td colspan="${lie/4}">${table.dateOfIn?table.dateOfIn:''}</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">粮食品种</td>
                      <td colspan="${lie/4}">${table.foodFariety?table.foodFariety:''}</td>
                      <td colspan="${lie/4}">实际储量</td>
                      <td colspan="${lie/4}">${table.storageReal||table.storageReal==0?table.storageReal:''}</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">入仓水分</td>
                      <td colspan="${lie/4}">${table.grainInWater||table.grainInWater==0?table.grainInWater:''}</td>
                      <td colspan="${lie/4}">当前水分</td>
                      <td colspan="${lie/4}">${table.grainWater||table.grainWater==0?table.grainWater:''}</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">检验人</td>
                      <td colspan="${lie/4}">${table.createBy?table.createBy:''}</td>
                      <td colspan="${lie/4}">保管员</td>
                      <td colspan="${lie/4}">${table.custodian?table.custodian:''}</td>
                    </tr>
                    <tr>
                      <td colspan="${lie/4}">粮情分析</td>
                      <td colspan="${lie-lie/4}"></td>
                    </tr>
                    <tr>
                      <td colspan="${lie/8}">粮食安危及虫害处理情况</td>
                      <td colspan="${lie/2-lie/8}"></td>
                      <td colspan="${lie/8}">"一符四无"粮食鉴定意见</td>
                      <td colspan="${lie/2-lie/8}"></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td  colspan="${lie/8}" class="sure">制表时间：</td>
                      <td colspan="${lie-lie/8}"></td>
                    </tr>
                  </tfoot>
                </table>			
              </body>
            </html>`
  }else if(wareType==3){
    tableInnerHTML+=`<table>
                      <thead>
                        <tr>
                          <th colspan="18" style="font-size:20px;font-family:'楷体';height:30px;">${table.wareName}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="2" style="width:120px">雷达高度</td>
                          <td colspan="2">${table.wareHeight?table.wareHeight:''}m</td>
                          <td colspan="2">油罐高度</td>
                          <td colspan="2">${table.height?table.height:''}m</td>
                          <td colspan="2">油位高</td>
                          <td colspan="2">${table.bitHeight?table.bitHeight:''}m</td>
                          <td colspan="2">平均温度(℃)</td>
                          <td colspan="2">最高温度(℃)</td>
                          <td colspan="2">最低温度(℃)</td>
                        </tr>
                        <tr>
                          <td colspan="2">油罐体积</td>
                          <td colspan="2">${table.wareVolume?table.wareVolume:''}m³</td>
                          <td colspan="2">油量(%)</td>
                          <td colspan="2">${table.percentage||table.percentage==0?table.percentage:''}</td>
                          <td colspan="2">油密度</td>
                          <td colspan="2"></td>
                          <td colspan="2">${table.tempAve||table.tempAve==0?table.tempAve:''}</td>
                          <td colspan="2">${table.tempMax||table.tempMax==0?table.tempMax:''}</td>
                          <td colspan="2">${table.tempMin||table.tempMin==0?table.tempMin:''}</td>
                        </tr>
                        <tr>
                          <td colspan="2">层</td>`
    for(let i=0;i<table.temps.length;i++){
      tableInnerHTML+=`<td>第${i+1}层</td>`
    }      
    for(let i=0;i<16-table.temps.length;i++){
      tableInnerHTML+=` <td></td>`
    }               
    tableInnerHTML+=`</tr>
                      <tr>
                      <td colspan="2">温度(℃)</td>`
    for(let i=0;i<table.temps.length;i++){
      tableInnerHTML+=`<td>${table.temps[i]}</td>`
    }
    for(let i=0;i<16-table.temps.length;i++){
      tableInnerHTML+=` <td></td>`
    }  
    tableInnerHTML+=`</tr>
                      <tr>
                        <td colspan="2">油脂品种</td>
                        <td colspan="7">${table.foodFariety?table.foodFariety:''}</td>
                        <td colspan="2">油脂性质</td>
                        <td colspan="7">${table.foodType?table.foodType:''}</td>
                      </tr>
                      <tr>
                        <td colspan="2">油脂等级</td>
                        <td colspan="7">${table.foodLevel?table.foodLevel:''}</td>
                        <td colspan="2">油脂产地</td>
                        <td colspan="7">${table.origin?table.origin:''}</td>
                      </tr>
                      <tr>
                        <td colspan="2">采集时间</td>
                        <td colspan="7">${table.currTime?table.currTime:''}</td>
                        <td colspan="2">保管员</td>
                        <td colspan="7">${table.custodian?table.custodian:''}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="2" class="sure">制表时间</td>
                        <td colspan="16">${nowDate}</td>
                      </tr>
                    </tfoot>
                  </table>			
                  </body>
                  </html>` 
  }
  function getExplorer() {
    var explorer = window.navigator.userAgent;
    if (explorer.indexOf('MSIE') >= 0) {
      return 'ie';  // ie
    } else if (explorer.indexOf('Firefox') >= 0) {
      return 'Firefox'; // firefox
    } else if (explorer.indexOf('Chrome') >= 0) {
      return 'Chrome'; // Chrome
    } else if (explorer.indexOf('Opera') >= 0) {
      return 'Opera';  // Opera
    } else if (explorer.indexOf('Safari') >= 0) {
      return 'Safari'; // Safari
    };
  };
  if (getExplorer() !== 'Safari' && name.substr(-1, 4) !== '.xls') {
    name += '.xls';
  }
  if (getExplorer() === 'ie') {
    var curTbl = table;
    var oXL = new ActiveXObject('Excel.Application');
    var oWB = oXL.Workbooks.Add();
    var xlsheet = oWB.Worksheets(1);
    var sel = document.body.createTextRange();
    sel.moveToElementText(curTbl);
    sel.select();
    sel.execCommand('Copy');
    xlsheet.Paste();
    oXL.Visible = true;
    try {
      var fname=oXL.Application.GetSaveAsFilename('Excel.xls', 'Excel Spreadsheets (*.xls), *.xls');
    } catch (e) {
      print('Nested catch caught ' + e);
    } finally {
      oWB.SaveAs(fname);
      // oWB.Close(savechanges = false);
      oXL.Quit();
      oXL = null;
      idTmr = setInterval(Cleanup(), 1);
    }
  } else {
    tableToExcel(tableInnerHTML, name);
  }
} 
function Cleanup() {
  window.clearInterval(idTmr);
}
let tableToExcel = (function () {
  let template = '<html><head><meta charset="UTF-8"></head><body><table>{table}</table></body></html>';
  let format = function (s, c) {
    return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; });
  };
  return function (table, name) {
    let ctx = { worksheet: name || 'Worksheet', table: table };
    let blob = new Blob([format(template, ctx)]);
    let a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download =name;  //这里这个name就是对应的文件名！
    a.click();
    a.remove();
  };
})();
export default transform;